<template>
  <section class="agency-signUp-main-sec">
    <div class="container-fluid">
      <div class="row">
        <div class="col-md-6">
          <div class="responsive-logo">
            <router-link class="desktopLogo" :to="{ path: '/login', query: authNavQuery }">
              <img src="@/assets/common/images/lbhq-logo.svg" />
            </router-link>
          </div>
          <router-link class="desktopLogo" :to="{ path: '/login', query: authNavQuery }">
            <img src="@/assets/common/images/lbhq-logo.svg" />
          </router-link>

          <!-- <div class="top-btn-box">
            <router-link to="">Sign in</router-link>
            <router-link :to="queryParam ? `register${queryParamValue}` : 'register'"
              >Sign Up</router-link
            >
          </div> -->

          <div class="top-btn-box">
            <router-link
              :to="{ path: '/login', query: authNavQuery }"
            >
              Sign in
            </router-link>

            <router-link
              :to="{ path: '/register', query: authNavQuery }"
            >
              Sign Up
            </router-link>
          </div>

          <div class="form-box signIn-form-box">
            <div class="text-heading">
              Welcome Back<br />
              to LinkBuilding HQ
            </div>
            <form>
              <div class="form-group">
                <label for="exampleInputEmail1">Email</label>
                <input
                  type="email"
                  @keyup.enter="handleEnterKey"
                  class="form-control"
                  v-model="email"
                  id="exampleInputEmail1"
                />
                <span
                  v-if="errors.email"
                  class="invalid-feedback"
                  style="display: block"
                  role="alert"
                >
                  <strong>{{ errors.email[0] }}</strong>
                </span>
              </div>
              <div class="form-group">
                <label for="exampleInputPassword1">Password</label>
                <input
                  v-bind:type="[showPassword ? 'text' : 'password']"
                  @keyup.enter="handleEnterKey"
                  v-model="password"
                  class="form-control"
                  id="exampleInputPassword1"
                  maxlength="64"
                />
                <span class="eye-icon" @click="showPassword = !showPassword">
                  <i class="fa" :class="[showPassword ? 'fa-eye-slash' : 'fa-eye']"></i>
                </span>

                <span
                  v-if="errors.password"
                  class="invalid-feedback"
                  style="display: block"
                  role="alert"
                >
                  <strong>{{ errors.password[0] }}</strong>
                </span>
              </div>
              <div class="form-group row signIn-field">
                <div class="col">
                  <div class="form-check">
                    <input
                      class="form-check-input"
                      v-model="remember"
                      type="checkbox"
                      id="gridCheck"
                    />
                    <label class="form-check-label" for="gridCheck"> Remember me </label>
                  </div>
                </div>

                <div class="col">
                  <router-link :to="{ path: '/forget-password', query: authNavQuery }">Forgot Password?</router-link>
                </div>
              </div>
              <button
                type="button"
                class="btn-1"
                @click="login"
                :class="{ disabled: !seen }"
              >
                {{ button.text }}
                <b-spinner small v-show="isLoading"></b-spinner>
              </button>

              <!-- <div class="sign-in-text">
                Dont't have an account?
                <router-link to="/register">Sign Up</router-link>
                <router-link :to="queryParam ? `register${queryParamValue}` : 'register'">Sign Up</router-link>
              </div> -->
            </form>
          </div>
        </div>

        <div class="col-md-6">
          <ContentBoxComponent></ContentBoxComponent>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { useToast } from "vue-toastification";
import ContentBoxComponent from "@/components/ContentBoxComponent.vue";
import { pushAnalyticsUserId } from "@/services/analyticsUserId.js";
import { withRouteRef } from "@/utils/affiliateRef";
const toast = useToast();

export default {
  name: "LoginView",
  components: {
    ContentBoxComponent,
  },
  async mounted() {
    this.$gtag = window.gtag;
    this.$gtag("get", "G-K51T6T1GCD", "client_id", (clientID) => {
      if (clientID) {
        this.effectiveUserId = clientID;
      }
    });

    window.document.body.style.paddingLeft = '0px';

    this.checkUrlParams();

    const url = new URL(window.location.href);
    const searchParams = new URLSearchParams(url.search);
    const type = searchParams.get("type");
    if (type == "impersonate") {
      var userId = searchParams.get("user_id");
      var token = searchParams.get("token");
      this.impersonateLogin(userId, token, type);
    }
  },
  data() {
    return {
      email: "",
      password: "",
      remember: false,
      isLoading: false,
      errors: [],
      button: {
        text: "Sign In",
      },
      seen: true,
      showPassword: false,
      queryParam: false,
      queryParamValue: {},
      effectiveUserId: "",
      data: {
        verification_code: "",
      },
    };
  },
  computed: {
    authNavQuery() {
      return withRouteRef(this.$route.query, this.queryParamValue);
    },
  },
  methods: {
    validatePasswordLength() {
      const password = String(this.password || "");
      if (password.length > 64) {
        this.errors.password = ["Password may not be greater than 64 characters."];
        return false;
      }
      return true;
    },
    handleEnterKey() {
      this.login();
    },
    getQueryParameterValue(parameterName) {
      var fromRoute = this.$route?.query?.[parameterName];
      if (fromRoute != null && fromRoute !== "") {
        return Array.isArray(fromRoute) ? fromRoute[0] : String(fromRoute);
      }
      var queryString = location.search.substring(1);
      var queryParams = queryString.split("&");

      for (var i = 0; i < queryParams.length; i++) {
        var eq = queryParams[i].indexOf("=");
        var key = eq === -1 ? queryParams[i] : queryParams[i].substring(0, eq);
        if (key === parameterName) {
          var raw = eq === -1 ? "" : queryParams[i].substring(eq + 1);
          return decodeURIComponent(raw);
        }
      }
      return null;
    },
    checkUrlParams() {
      var daValue = this.getQueryParameterValue("da");
      var categoryValue = this.getQueryParameterValue("category");
      var sourceValue = this.getQueryParameterValue("utm_source");
      var mediumValue = this.getQueryParameterValue("utm_medium");
      var campaignValue = this.getQueryParameterValue("utm_campaign");
      var webOrder = this.getQueryParameterValue("order");
      var mediaLinksData = this.getQueryParameterValue("media_links_data");
      var brandMentionsData = this.getQueryParameterValue("brand_mentions_data");

      this.queryParamValue = {};

      if (webOrder !== null) {
        this.queryParamValue.order = webOrder;
      }

      if (mediaLinksData !== null) {
        this.queryParamValue.media_links_data = mediaLinksData;
      }

      if (brandMentionsData !== null) {
        this.queryParamValue.brand_mentions_data = brandMentionsData;
      }

      if (sourceValue) {
        this.queryParamValue.utm_source = sourceValue;
      }

      if (mediumValue) {
        this.queryParamValue.utm_medium = mediumValue;
      }

      if (campaignValue) {
        this.queryParamValue.utm_campaign = campaignValue;
      }

      if (daValue !== null && categoryValue !== null) {
        this.data.da = daValue;
        this.data.category = categoryValue;

        // overwrite / set new keys
        this.queryParamValue = {
          da: daValue,
          category: categoryValue
        };

        if (sourceValue) {
          this.queryParamValue.utm_source = sourceValue;
        }
        if (mediumValue) {
          this.queryParamValue.utm_medium = mediumValue;
        }
        if (campaignValue) {
          this.queryParamValue.utm_campaign = campaignValue;
        }
        if (webOrder !== null) {
          this.queryParamValue.order = webOrder;
        }
        if (mediaLinksData !== null) {
          this.queryParamValue.media_links_data = mediaLinksData;
        }
        if (brandMentionsData !== null) {
          this.queryParamValue.brand_mentions_data = brandMentionsData;
        }
      }

      this.queryParam = true;

      if (this.$route.query.verification_code) {
        this.data.verification_code = this.$route.query.verification_code;
        this.verification();
      }
    },
    getPostAuthRedirect() {
      const query = { ...this.queryParamValue };
      delete query.ref;
      const postAuthRedirect = sessionStorage.getItem("post_auth_redirect");
      sessionStorage.removeItem("post_auth_redirect");

      if (this.queryParam && this.queryParamValue.order) {
        return { path: "/product", query };
      }
      if (this.queryParam && this.queryParamValue.media_links_data) {
        return { path: "/media-links-summary", query };
      }
      if (this.queryParam && this.queryParamValue.brand_mentions_data) {
        return { path: "/brand-mentions", query };
      }
      if (postAuthRedirect === "media-links") {
        return { path: "/media-links", query };
      }
      return { path: "/dashboard", query };
    },
    async login() {
      if (!this.validatePasswordLength()) {
        return;
      }
      this.isLoading = true;
      try {
        let res = await this.$store.dispatch("Auth/loginAction", {
          email: this.email,
          password: this.password,
          remember: this.remember,
          effective_user_id: this.effectiveUserId,
        });
        this.isLoading = false;
        if (res.success) {
          pushAnalyticsUserId(res.data?.user_id);
        }
        toast.success(res.message, { timeout: 3000 });
        this.$router.push(this.getPostAuthRedirect());
      } catch (error) {
        this.isLoading = false;
        this.errors = error.response.data.errors;
      }
    },
    async verification() {
      this.loading = true;
      try {
        let res = await this.$store.dispatch(
          "Auth/isEmailVerifiedAction",
          {
            verification_code: this.data.verification_code,
          },
          {
            root: true,
          }
        );
        if (res.success) {
          this.confirmShowBox = false;
        }
        this.loading = false;
        // Preserve UTM / marketing query params (same as normal login)
        this.$router.push(this.getPostAuthRedirect());
        toast.success(res.message, { timeout: 3000 });
      } catch (error) {
        this.loading = false;
        toast.error(error.response.data.errors, { timeout: 3000 });
        this.errors = error.response.data.errors;
      }
    },
    async impersonateLogin(userId, token, type) {
      this.isLoading = true;
      try {
        let res = await this.$store.dispatch("Auth/impersonateLoginAction", {
          token: token,
          user_id: userId,
        });

        if (res.success) {
          localStorage.setItem("impersonate-login", type);
          pushAnalyticsUserId(res.data?.user_id);
          this.isLoading = false;
          toast.success(res.message, { timeout: 3000 });
          this.$router.push("/dashboard");
        }
      } catch (error) {
        this.isLoading = false;
        toast.error(error.response.data.errors, { timeout: 3000 });
      }
    },
  },
};
</script>
